export default __webpack_public_path__ + "static/media/place.cfd8692e.svg";